import { createElement, ReactElement } from 'react';

import { BaseModule } from '@components';
import { Module, Variant } from '@types';

import { SubModuleRegistry } from './SubModuleRegistry';
import { addToRollbarContext } from '../utils/rollbar';

// Variant configs are ~1.5 KB each; bundling them removes a round trip before the first screen.
const variantConfigs = import.meta.glob<Variant>('../variants/*.json', {
  eager: true,
  import: 'default',
});

export const loadVariantConfig = async (variant: string): Promise<Variant> => {
  const config = variantConfigs[`../variants/${variant}.json`];
  if (!config) throw new Error(`Unknown variant "${variant}"`);
  addToRollbarContext({ variant });
  return config;
};

export const generateModules = async (
  variant: string
): Promise<ReactElement[]> => {
  const config = await loadVariantConfig(variant);
  return config.modules.map((module: Module, index: number) => {
    const subModulesComponents = module.subModules
      .filter((name) => name)
      .map((subModuleName: string) => {
        const SubModuleComponent =
          SubModuleRegistry.getSubModule(subModuleName);
        return SubModuleComponent
          ? createElement(SubModuleComponent, {
              key: subModuleName,
            })
          : null;
      });

    return createElement(BaseModule, {
      key: index,
      children: subModulesComponents,
    });
  });
};
